import React, {
  createContext,
  useEffect,
  useReducer,
  useCallback
} from 'react';
import gql from 'graphql-tag';
import useIsMountedRef from 'src/hooks/useIsMountedRef';
import client from 'src/utils/GQLCompanyClient';
import SettingsClient from 'src/utils/GQLSettingsClient';
import fetchDocumentImage from 'src/components/get_document_image_report';
import DVSClient from 'src/utils/GQLDVSClient';
import { useHistory } from 'react-router-dom';

require('dotenv').config();

const initialAuthState = {
  stream: '',
  isInitialised: false,
  image: null
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_STREAM': {
      const { stream, isInitialised, image } = action.payload;
      return {
        ...state,

        stream,
        isInitialised,
        image
      };
    }

    default: {
      return { ...state };
    }
  }
};

const StreamContext = createContext({
  ...initialAuthState,
  setStream: () => Promise.resolve(),
  getStreams: () => Promise.resolve()
});

export const StreamProvider = ({ children }) => {
  // const { setStream } = useStream();
  const isMountedRef = useIsMountedRef();
  const history = useHistory();

  
  const [state, dispatch] = useReducer(reducer, initialAuthState);

  const setStream = async (app, id, stream_code , image) => {
    try {
      dispatch({
        type: 'SET_STREAM',
        payload: {
          stream: '',
          isInitialised: false,
          image: null
        }
      });
      const ADD = gql`
        mutation MyMutation(
          $app_name: String
          $session_key: String
          $session_value: String
        ) {
          add_session_value(
            app_name: $app_name
            session_key: $session_key
            session_value: $session_value
          ) {
            _id
          }
        }
      `;

      const { data } = await DVSClient
        .mutate({
          mutation: ADD,
          variables: {
            app_name: app,
            session_key: id,
            session_value: stream_code
          }
        })
        .then(res => {
          //history.push( '/app/home');
          window.location.reload();

          return res;
        });
        console.log(data)
    } catch (err) {
      // console.log(err);
      if (err.response) {
        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      // console.log(err.message);
    }
  };
  const getStreams = useCallback(async () => {
    try {
      const getstudents = gql`
        query MyQuery {
          get_exam_faculty_by_email {
            _id
            session_details {
              app_name
              session_key
              session_value
            }
          }
        }
      `;

      const { data } = await DVSClient
        .query({
          query: getstudents,
          fetchPolicy: 'network-only'
        })
        .then(res => {
          // console.log(res);
          return res;
        });

      if (isMountedRef.current) {
        // console.log('get_exam_faculty_by_email', data.get_exam_faculty_by_email);
        const value = data.get_exam_faculty_by_email.session_details.find(
          x => x.app_name === 'dvs' && x.session_key === 'schedule'
        );
        try {
          const getstudents = gql`
            query MyQuery {
              get_schedules {
                _id
    end_date
    name
    start_date
    stream
    status
    term
    course_scheme
    exam_schedule_id
    valuation_status
              }
            }
          `;

          const { data } = await DVSClient
            .query({
              query: getstudents,
              fetchPolicy: 'network-only'
            })
            .then(res => {
              // console.log(res);

              return res;
            });
           console.log("value" , value);
          if(data.get_schedules.find((sched) => sched._id === value.session_value) === undefined){
            const value2 = data.get_schedules[0];
            await setStream('dvs', 'schedule', value2._id);
          }
          if (!value) {
            const value2 = data.get_schedules[0];
            await setStream('dvs', 'schedule', value2._id);
            // window.location.reload();
          } else {
            if (isMountedRef.current) {
              const value1 = data.get_schedules.find(
                x => x._id === value.session_value
              );

                dispatch({
                  type: 'SET_STREAM',
                  payload: {
                    stream: value1,
                    isInitialised: true,
                    image: null
                  }
                });
              
            }
          }
        } catch (err) {
          console.error(err);
        }
      }
    } catch (err) {
      console.error(err);
    }
  }, [isMountedRef]);

  useEffect(() => {
    getStreams();
  }, [getStreams]);

  return (
    <StreamContext.Provider
      value={{
        ...state,
        setStream,
        getStreams
      }}
    >
      {children}
    </StreamContext.Provider>
  );
};

export default StreamContext;
